var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadlockOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2692 3.3732C15.2201 2.3285 13.7982 1.74447 12.3178 1.75004C9.24255 1.75147 6.75004 4.24486 6.75004 7.32041V9.2552C4.97631 10.0978 3.75 11.9057 3.75 14V16C3.75 18.8995 6.1005 21.25 9 21.25H15C17.8995 21.25 20.25 18.8995 20.25 16V14C20.25 11.1005 17.8995 8.75 15 8.75H9.25004V7.32041C9.25004 5.62469 10.6247 4.25004 12.3204 4.25004H12.3257V4.25003C13.1423 4.24657 13.9266 4.56852 14.5052 5.1447C14.9944 5.63183 15.7858 5.63015 16.273 5.14097C16.7601 4.65178 16.7584 3.86033 16.2692 3.3732ZM13.3 13.75C13.3 13.0596 12.7403 12.5 12.05 12.5C11.3596 12.5 10.8 13.0596 10.8 13.75V16.25C10.8 16.9404 11.3596 17.5 12.05 17.5C12.7403 17.5 13.3 16.9404 13.3 16.25V13.75Z",
    fill: "inherit"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockOpen);
export default __webpack_public_path__ + "static/media/padlockOpen.98415fa9.svg";
export { ForwardRef as ReactComponent };